import { Controller } from '@hotwired/stimulus';

/**
 * Panneau plein écran mobile du header d'onboarding (< sm).
 *
 * Le header public a le même comportement, mais il est piloté par
 * `layout#toggleFullscreenHeader`, qui cible en dur l'id `public-nav` et la classe
 * `body.header_open` : les réutiliser ici coupleraient les deux headers (et le
 * `querySelector('[aria-controls="public-nav"]')` du contrôleur `layout` retomberait sur le
 * mauvais bouton dès que les deux cohabiteraient). Ce contrôleur est donc autonome et ne
 * manipule que ses propres cibles.
 */
export default class extends Controller<HTMLElement> {
  static targets = ['button', 'panel'];

  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly panelTarget: HTMLElement;

  toggle (event: Event): void {
    event.preventDefault();

    const isOpen = this.panelTarget.classList.toggle('hidden') === false;

    this.panelTarget.classList.toggle('flex', isOpen);
    // Verrou de défilement de l'arrière-plan, équivalent de `body.header_open` côté public.
    document.body.classList.toggle('overflow-hidden', isOpen);
    this.buttonTarget.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  disconnect (): void {
    document.body.classList.remove('overflow-hidden');
  }
}
